import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { omit } from "es-toolkit/object";
import { useEffect, useMemo, useState } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../../../components/Button";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { TransactionReceipt } from "../../../../../components/TransactionReceipt";
import { TransactionReceiptFragment } from "../../../../../components/TransactionReceipt/TransactionReceipt.fragment";
import { FlowState } from "../../../../../stores/flowStore";
import { useSetReceiptStatus, useSetReceiptStatusFragment } from "../../../../hooks/useSetReceiptStatus";
const FETCH_INTERVAL = 500;
const query = graphql(`
    query AcceptOfferFlowStatusQuery(
      $transactionIdentifiers: [TransactionIdentifier!]!
      $itemQuotes: [ItemQuoteInput!]!
      $swapProvider: SwapProviderType!
    ) {
      buyReceipt(
        transactionIdentifiers: $transactionIdentifiers
        itemQuotes: $itemQuotes
        swapProvider: $swapProvider
      ) {
        status
        itemReceipts {
          __typename
          item {
            id
          }
        }
        failedItemReceipts {
          __typename
          item {
            id
          }
        }
        ...useSetReceiptStatus
        ...TransactionReceipt
      }
    }
  `, [TransactionReceiptFragment, useSetReceiptStatusFragment]);
export const AcceptOfferStatus = t0 => {
  const $ = _c(77);
  const {
    transactionIdentifiers,
    itemQuotes,
    itemImageMap
  } = t0;
  let t1;
  if ($[0] !== itemQuotes || $[1] !== transactionIdentifiers) {
    t1 = {
      query,
      variables: {
        transactionIdentifiers,
        itemQuotes,
        swapProvider: "LOCAL_BUY_NFT"
      },
      pause: true
    };
    $[0] = itemQuotes;
    $[1] = transactionIdentifiers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [result, reexecuteQuery] = useQuery(t1);
  const t = useTranslations("wallet.AcceptOfferStatus");
  let t2;
  if ($[3] !== reexecuteQuery || $[4] !== result.data || $[5] !== result.fetching || $[6] !== transactionIdentifiers.length) {
    t2 = function pollForReceipt() {
      if (result.fetching || result.data?.buyReceipt && result.data.buyReceipt.status !== "PENDING" || transactionIdentifiers.length === 0) {
        return;
      }
      const timerId = setTimeout(() => {
        reexecuteQuery({
          requestPolicy: "network-only"
        });
      }, FETCH_INTERVAL);
      return () => clearTimeout(timerId);
    };
    $[3] = reexecuteQuery;
    $[4] = result.data;
    $[5] = result.fetching;
    $[6] = transactionIdentifiers.length;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = result.data?.buyReceipt;
  let t4;
  if ($[8] !== reexecuteQuery || $[9] !== result.fetching || $[10] !== t3 || $[11] !== transactionIdentifiers.length) {
    t4 = [result.fetching, reexecuteQuery, t3, transactionIdentifiers.length];
    $[8] = reexecuteQuery;
    $[9] = result.fetching;
    $[10] = t3;
    $[11] = transactionIdentifiers.length;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  useEffect(t2, t4);
  const receipt = result.data?.buyReceipt;
  useSetReceiptStatus(receipt);
  const [receiptOpen, setReceiptOpen] = useState(false);
  if (!receipt || receipt.status === "PENDING") {
    let t5;
    if ($[13] !== itemImageMap) {
      t5 = Object.values(itemImageMap);
      $[13] = itemImageMap;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    const pendingImages = t5;
    let t6;
    if ($[15] !== t) {
      t6 = t("pending.description");
      $[15] = t;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t7;
    if ($[17] !== t) {
      t7 = t("pending.title");
      $[17] = t;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== pendingImages || $[20] !== t6 || $[21] !== t7) {
      t8 = <TransactionFullScreen body={t6} images={pendingImages} loading={true} title={t7} />;
      $[19] = pendingImages;
      $[20] = t6;
      $[21] = t7;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  if (receipt.status === "FAILED") {
    let t5;
    if ($[23] !== t) {
      t5 = t("failed.description");
      $[23] = t;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== receipt || $[26] !== receiptOpen || $[27] !== t) {
      t6 = receiptOpen ? <TransactionReceipt flowType="acceptOffer" receipt={receipt} /> : <Button onClick={() => setReceiptOpen(true)} variant="secondary">{t("viewReceipt")}</Button>;
      $[25] = receipt;
      $[26] = receiptOpen;
      $[27] = t;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    let t7;
    if ($[29] !== itemImageMap || $[30] !== receipt.failedItemReceipts) {
      let t8;
      if ($[32] !== itemImageMap) {
        t8 = item => item.item ? itemImageMap[item.item.id] : null;
        $[32] = itemImageMap;
        $[33] = t8;
      } else {
        t8 = $[33];
      }
      t7 = receipt.failedItemReceipts.map(t8);
      $[29] = itemImageMap;
      $[30] = receipt.failedItemReceipts;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    let t8;
    if ($[34] !== t) {
      t8 = t("failed.title");
      $[34] = t;
      $[35] = t8;
    } else {
      t8 = $[35];
    }
    let t9;
    if ($[36] !== t5 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8) {
      t9 = <TransactionFullScreen body={t5} bottom={t6} images={t7} monochrome={true} title={t8} />;
      $[36] = t5;
      $[37] = t6;
      $[38] = t7;
      $[39] = t8;
      $[40] = t9;
    } else {
      t9 = $[40];
    }
    return t9;
  }
  if (receipt.status === "PARTIAL_SUCCESS") {
    let t5;
    if ($[41] !== receipt.failedItemReceipts.length || $[42] !== receipt.itemReceipts.length || $[43] !== t) {
      t5 = t("partialSuccess.description", {
        itemsSoldCount: receipt.itemReceipts.length,
        itemsFailedCount: receipt.failedItemReceipts.length
      });
      $[41] = receipt.failedItemReceipts.length;
      $[42] = receipt.itemReceipts.length;
      $[43] = t;
      $[44] = t5;
    } else {
      t5 = $[44];
    }
    let t6;
    if ($[45] !== receipt || $[46] !== receiptOpen || $[47] !== t) {
      t6 = receiptOpen ? <TransactionReceipt flowType="acceptOffer" receipt={receipt} /> : <Button onClick={() => setReceiptOpen(true)} variant="secondary">{t("viewReceipt")}</Button>;
      $[45] = receipt;
      $[46] = receiptOpen;
      $[47] = t;
      $[48] = t6;
    } else {
      t6 = $[48];
    }
    let t7;
    if ($[49] !== itemImageMap || $[50] !== receipt.itemReceipts) {
      let t8;
      if ($[52] !== itemImageMap) {
        t8 = item_0 => item_0.item ? itemImageMap[item_0.item.id] : null;
        $[52] = itemImageMap;
        $[53] = t8;
      } else {
        t8 = $[53];
      }
      t7 = receipt.itemReceipts.map(t8);
      $[49] = itemImageMap;
      $[50] = receipt.itemReceipts;
      $[51] = t7;
    } else {
      t7 = $[51];
    }
    let t8;
    if ($[54] !== t) {
      t8 = t("partialSuccess.title");
      $[54] = t;
      $[55] = t8;
    } else {
      t8 = $[55];
    }
    let t9;
    if ($[56] !== t5 || $[57] !== t6 || $[58] !== t7 || $[59] !== t8) {
      t9 = <TransactionFullScreen body={t5} bottom={t6} images={t7} title={t8} />;
      $[56] = t5;
      $[57] = t6;
      $[58] = t7;
      $[59] = t8;
      $[60] = t9;
    } else {
      t9 = $[60];
    }
    return t9;
  }
  let t5;
  if ($[61] !== receipt || $[62] !== receiptOpen || $[63] !== t) {
    t5 = receiptOpen ? <TransactionReceipt flowType="acceptOffer" receipt={receipt} /> : <Button onClick={() => setReceiptOpen(true)} variant="secondary">{t("viewReceipt")}</Button>;
    $[61] = receipt;
    $[62] = receiptOpen;
    $[63] = t;
    $[64] = t5;
  } else {
    t5 = $[64];
  }
  let t6;
  if ($[65] !== itemImageMap || $[66] !== receipt.itemReceipts) {
    let t7;
    if ($[68] !== itemImageMap) {
      t7 = item_1 => item_1.item ? itemImageMap[item_1.item.id] : null;
      $[68] = itemImageMap;
      $[69] = t7;
    } else {
      t7 = $[69];
    }
    t6 = receipt.itemReceipts.map(t7);
    $[65] = itemImageMap;
    $[66] = receipt.itemReceipts;
    $[67] = t6;
  } else {
    t6 = $[67];
  }
  let t7;
  if ($[70] !== receipt.itemReceipts.length || $[71] !== t) {
    t7 = t("success.title", {
      count: receipt.itemReceipts.length
    });
    $[70] = receipt.itemReceipts.length;
    $[71] = t;
    $[72] = t7;
  } else {
    t7 = $[72];
  }
  let t8;
  if ($[73] !== t5 || $[74] !== t6 || $[75] !== t7) {
    t8 = <TransactionFullScreen bottom={t5} confetti={true} images={t6} title={t7} />;
    $[73] = t5;
    $[74] = t6;
    $[75] = t7;
    $[76] = t8;
  } else {
    t8 = $[76];
  }
  return t8;
};
export function AcceptOfferFlowStatus() {
  const $ = _c(8);
  const {
    receiptTransactions,
    itemQuotes,
    itemImageMap
  } = useSnapshot(FlowState);
  let t0;
  let t1;
  if ($[0] !== itemQuotes) {
    t1 = itemQuotes.map(_temp);
    $[0] = itemQuotes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const itemQuoteInputs = t0;
  let t2;
  if ($[2] !== receiptTransactions) {
    t2 = receiptTransactions.map(_temp2);
    $[2] = receiptTransactions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== itemImageMap || $[5] !== itemQuoteInputs || $[6] !== t2) {
    t3 = <AcceptOfferStatus itemImageMap={itemImageMap} itemQuotes={itemQuoteInputs} transactionIdentifiers={t2} />;
    $[4] = itemImageMap;
    $[5] = itemQuoteInputs;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp2(txn) {
  return {
    chain: txn.chain,
    transactionHash: txn.hash
  };
}
function _temp(itemQuote) {
  return omit(itemQuote, ["orderId"]);
}